export const products = [
  {
    id: "sn-1",
    name: "Postbiotic Energy Drink",
    brand: "ARIH by BTS",
    category: "Bebidas",
    price: 160,
    image: "https://i.pinimg.com/736x/b5/92/68/b59268fbd0e67b1b15b7683d4cb2795f.jpg",
    weight: "355ml",
    flavorTags: ["Caffeine", "0 azucar", "BTS"],
    isSpicy: false,
    sabores: [
      { name: "Blush Berry", stock: false, image: "https://i5.walmartimages.com/seo/ARIH-Postbiotic-Energy-Drink-Blush-Berry-Single-Can_5e24a5e7-e9c0-41f9-9880-0f6e8b188e67.85f34b0980f73c88af1594966d484548.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "Cherry Nova", stock: false, image: "https://i5.walmartimages.com/seo/ARIH-Postbiotic-Energy-Drink-Cherry-Nova-Single-Can_e8bbc19b-8f25-42d2-8ddc-478c1bfc63be.587c7b1e1e333d6a758bd9176784487c.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "Jolly Strawberry", stock: false, image: "https://i5.walmartimages.com/seo/ARIH-Postbiotic-Energy-Drink-Jolly-Strawberry-Single-Can_ab943c68-84c9-4e5b-8a0e-969f8d892320.d86e877e1cee0a08dc9708dcb32f152e.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF" }, 
      { name: "Lemon Crest", stock: false,image: "https://i5.walmartimages.com/seo/ARIH-Postbiotic-Energy-Drink-Lemon-Crest-Single-Can_be33a7f9-8ddb-4182-98bf-ff97300ad546.99b4bc744fdc0a96798f4e93b347739e.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF" },
      { name: "Orange Hour", stock: false, image: "https://i5.walmartimages.com/seo/ARIH-Postbiotic-Energy-Drink-Orange-Hour-Single-Can_b0afe140-66bd-42c6-9569-691434c04713.aa3f6897fe5ee673404f62e04f4ac65d.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "Peachy Sunshine", stock: false, image: "https://i5.walmartimages.com/seo/ARIH-Postbiotic-Energy-Drink-Peachy-Sunshine-Single-Can_a1e14041-a2ec-4c69-a174-4fe8ab72295b.8d1e836422617bd231e32b5316b8868f.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "Tropical Wave", stock: false, image: "https://i5.walmartimages.com/seo/ARIH-Postbiotic-Energy-Drink-Tropical-Wave-Single-Can_8594731a-0d19-4f3d-ad4f-66b7062ec13e.384e8a626c95c2b74c5110b6a20ff387.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF" }, 
    ]
  },
  {
    id: "sn-2",
    name: "Modern Noodles",
    brand: "ARIH by BTS",
    category: "Noodles",
    price: 90,
    image: "https://i.pinimg.com/736x/e5/45/24/e54524a26385d728135e7f72ffeece63.jpg",
    weight: "130 gramos",
    flavorTags: ["Caffeine", "0 azucar", "BTS"],
    isSpicy: false,
    sabores: [
      { name: "Black Pepper Tteokbokki", stock: false, image: "https://arih.com/cdn/shop/files/ARIH_noodle_pillow_black_pepper_tteokbokki.png?v=1773408096&width=1364"},
      { name: "Doenjang Butter", stock: false, image: "https://arih.com/cdn/shop/files/noodle_pillow_doenjang_butter_ba73a85c-35da-4db4-a563-7c693a4ff695.png?v=1791326603&width=1364"},
      { name: "Gochujang Butter", stock: false, image: "https://arih.com/cdn/shop/files/ARIH_noodle_pillow_gochujang_butter.png?v=1773408096&width=1364" }, 
      { name: "Vongole", stock: false, image: "https://arih.com/cdn/shop/files/ARIH_noodle_pillow_vongole.png?v=1773408096&width=1364"},
      { name: "Spicy Seaweed", stock: false,image: "https://arih.com/cdn/shop/files/ARIH_noodle_pillow_spicy_seaweed.png?v=1773408096&width=1364"},
      { name: "Truffle Bulgogi", stock: false, image: "https://arih.com/cdn/shop/files/ARIH_noodle_pillow_truffle_bulgogi.png?v=1773408096&width=1364"},
      { name: "Soy Sauce Butter", stock: false, image: "https://arih.com/cdn/shop/files/ARIH_noodle_pillow_soy_sauce_butter.png?v=1773408096&width=1364"},
      { name: "K-Super Spicy Seaweed", stock: false, image: "https://arih.com/cdn/shop/files/ARIH_noodle_pillow_ksuper_spicy_seaweed.png?v=1773408096&width=1364" }, 
    ]
  },
  {
    id: "sn-3",
    name: "Dual Biotic Soda",
    brand: "ARIH by BTS",
    category: "Bebidas",
    price: 1,
    image: "https://i.pinimg.com/736x/81/bb/80/81bb80373b9c844de01eb0889da94973.jpg",
    weight: "355ml",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "Apple Flare", stock: false, image: "https://i5.walmartimages.com/asr/b3136f55-20ea-469c-9b62-955c31fa5734.8c10fe49043193871a20b18ae6c8df73.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "Berry Bliss", stock: false, image: "https://i5.walmartimages.com/asr/456812f3-0fd2-4521-a8d6-634c071d7080.d35bd6330b0564c0610dea406545487d.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "Clear Lemon", stock: false, image: "https://i5.walmartimages.com/asr/1ec6c8a3-97ba-46ca-830f-211a5132c0a2.661562feb3b22669f3159441ee7fa34b.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF" }, 
      { name: "Peach Mango Horizon", stock: false, image: "https://i5.walmartimages.com/asr/d657a99f-527d-484e-bb54-c2d7390533fe.e467bdb3ebf4cba39679f75dedec863b.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "Pineapple Drift", stock: false, image: "https://i5.walmartimages.com/asr/0ab8eaf4-9e3c-45a2-a927-733da56005e8.e633527b3b27c3152b2581f2908f9535.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "Positive Orange", stock: false, image: "https://i5.walmartimages.com/asr/b4422539-040e-4821-b53a-6bca0964f30a.23847a3cafbbb6cb3c57f05b74137460.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF" }, 
      { name: "Red Ruby Galore", stock: false, image: "https://i5.walmartimages.com/asr/8d4e63db-8acd-41a6-a489-c832021dd539.b4d499dfbfbc088d123de26694610f36.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
    ]
  },
    {
    id: "sn-4",
    name: "Modern Noodles Bowl",
    brand: "ARIH by BTS",
    category: "Noodles",
    price: 90,
    image: "https://i.pinimg.com/736x/be/eb/fc/beebfcb13e5d8dd126f68f22de104681.jpg",
    weight: "130 gramos",
    flavorTags: ["Caffeine", "0 azucar", "BTS"],
    isSpicy: false,
    sabores: [
      { name: "Black Pepper Tteokbokki", stock: false, image: "https://i5.walmartimages.com/seo/ARIH-Modern-Noodles-Premium-K-food-Inspired-Soup-Less-Noodles-Black-Pepper-Tteokbokki-Bowl_15721405-4ca5-4d42-89e8-a77e1e4955fe.335bdd7b308e50c0e2e54db9a27588c1.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "Gochujang Butter", stock: false, image: "https://i5.walmartimages.com/seo/ARIH-Modern-Noodles-Premium-K-food-Inspired-Soup-Less-Noodles-Gochujang-Butter-Bowl_8006960a-e3dd-4e16-b4fb-14365e69d002.02d41914327d2235b7c9bd3227d705da.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF" }, 
      { name: "Vongole", stock: false, image: "https://i5.walmartimages.com/seo/ARIH-Modern-Noodles-Premium-K-food-Inspired-Soup-Less-Noodles-Vongole-Bowl_905d3bf5-8afe-4b33-a8d0-c29c6b29fa9d.c6cf1ca1626c8aa7312976befbd83420.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "Spicy Seaweed", stock: false,image: "https://i5.walmartimages.com/seo/ARIH-Modern-Noodles-Premium-K-food-Inspired-Soup-Less-Noodles-Spicy-Seaweed-Bowl_ddd8074c-abcd-4e07-a760-70e5275e725f.ecce8abe88b093ce19399b74597906a0.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "Truffle Bulgogi", stock: false, image: "https://i5.walmartimages.com/seo/ARIH-Modern-Noodles-Premium-K-food-Inspired-Soup-Less-Noodles-Truffle-Bulgogi-Bowl_55ecea4f-311d-47ba-b588-e92aab6dfb5c.3bd89ad416ed68d7193b6028912cf10f.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "Soy Sauce Butter", stock: false, image: "https://i5.walmartimages.com/seo/ARIH-Modern-Noodles-Premium-K-food-Inspired-Soup-Less-Noodles-Soy-Sauce-Butter-Bowl_d3042083-9158-4f52-a561-63dafc2e386b.26c5b4b4db0cab6e2112d7c92feea87a.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"},
      { name: "K-Super Spicy Seaweed", stock: false, image: "https://i5.walmartimages.com/seo/ARIH-Modern-Noodles-Premium-K-food-Inspired-Soup-Less-Noodles-K-Super-Spicy-Seaweed-Bowl_e166a2bc-847c-487e-8598-62404269ec80.52041cd314a32e612a7776770e7acab4.png?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },
  {
    id: "sn-",
    name: " ",
    brand: "",
    category: "",
    price: 1,
    image: "",
    weight: "",
    flavorTags: ["", "0", ""],
    isSpicy: false,
    sabores: [
      { name: "", stock: false, image: ""},
      { name: " ", stock: false, image: ""},
      { name: " ", stock: false, image: "" }, 
    ]
  },



];